// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/interview-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   READINESS CHECK SCREEN - G42 BRANDING
   ========================================== */

.readiness-container {
  min-height: 100vh;
  background: var(--interview-bg-main);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--interview-space-3xl) var(--interview-space-lg);
  font-family: var(--interview-font-primary);
}

.readiness-heading {
  font-size: 1.4375rem;
  font-weight: var(--interview-text-bold);
  color: var(--interview-text-primary);
  margin: 0 0 7px 0;
  text-align: center;
  line-height: 1.3;
  letter-spacing: 0;
}

.readiness-subheading {
  font-size: 0.875rem;
  color: var(--interview-text-muted);
  margin: 0 0 24px 0;
  text-align: center;
  line-height: 1.6;
  font-weight: var(--interview-text-regular);
}

.readiness-checksContainer {
  display: flex;
  flex-direction: column;
  gap: 11px;
  margin-bottom: 22px;
}

.readiness-checkItem {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: var(--interview-radius-xl);
  background-color: var(--interview-bg-card);
  transition: all var(--interview-transition-base);
  border: 1.5px solid var(--interview-border-light);
}

.readiness-checkItem.readiness-ok {
  background-color: var(--interview-success-light);
  border-color: var(--interview-success-border);
}

.readiness-checkItem.readiness-fail {
  background-color: var(--interview-error-light);
  border-color: var(--interview-error-border);
}

.readiness-checkItem.readiness-loading {
  border-color: var(--interview-border-light);
}

.readiness-checkIcon {
  width: 36px;
  height: 36px;
  border-radius: var(--interview-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  background-color: var(--interview-bg-white);
  flex-shrink: 0;
}

.readiness-checkItem.readiness-ok .readiness-checkIcon {
  background: var(--interview-success-lighter);
  color: var(--interview-brand-primary);
}

.readiness-checkItem.readiness-fail .readiness-checkIcon {
  background: var(--interview-error-light);
  color: var(--interview-error);
}

.readiness-checkItem.readiness-loading .readiness-checkIcon {
  background: #EBF4FC;
  color: #3D8FD6;
}

.readiness-checkContent {
  flex: 1;
  min-width: 0;
}

.readiness-checkTitle {
  font-size: 0.875rem;
  font-weight: var(--interview-text-semibold);
  color: var(--interview-text-primary);
  margin: 0 0 2px 0;
  line-height: 1.3;
}

.readiness-checkDescription {
  font-size: 0.78125rem;
  color: var(--interview-text-muted);
  margin: 0;
  line-height: 1.4;
  font-weight: var(--interview-text-regular);
}

.readiness-checkStatus {
  width: 24px;
  height: 24px;
  border-radius: var(--interview-radius-circle);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  flex-shrink: 0;
  margin-left: auto;
}

.readiness-checkItem.readiness-ok .readiness-checkStatus {
  color: var(--interview-brand-primary);
}

.readiness-checkItem.readiness-fail .readiness-checkStatus {
  color: var(--interview-error);
}

.readiness-checkItem.readiness-loading .readiness-checkStatus {
  color: #3D8FD6;
}

.readiness-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid var(--interview-border-default);
  border-top-color: var(--interview-brand-primary);
  border-radius: var(--interview-radius-circle);
  animation: readiness-spin 0.8s linear infinite;
}

@keyframes readiness-spin {
  to {
    transform: rotate(360deg);
  }
}

.readiness-languageSection {
  margin-bottom: var(--interview-space-2xl);
}

.readiness-languageLabel {
  font-size: var(--interview-text-sm);
  font-weight: var(--interview-text-semibold);
  color: var(--interview-text-muted);
  margin-bottom: var(--interview-space-sm);
  display: block;
}

.readiness-languageSelect {
  width: 100%;
  padding: var(--interview-space-md) var(--interview-space-lg);
  border: 1px solid var(--interview-border-light);
  border-radius: var(--interview-radius-lg);
  font-size: var(--interview-text-base);
  font-family: var(--interview-font-primary);
  background-color: var(--interview-bg-white);
  cursor: pointer;
  color: var(--interview-text-primary);
  font-weight: var(--interview-text-medium);
  transition: all var(--interview-transition-base);
}

.readiness-languageSelect:focus {
  outline: none;
  border-color: var(--interview-brand-primary);
  box-shadow: var(--interview-shadow-focus);
}

.readiness-consentSection {
  background-color: var(--interview-success-light);
  padding: var(--interview-space-lg);
  border-radius: var(--interview-radius-xl);
  margin-bottom: var(--interview-space-2xl);
  border: 1px solid var(--interview-success-border);
}

.readiness-consentCheckbox {
  display: flex;
  align-items: flex-start;
  gap: var(--interview-space-md);
}

.readiness-checkbox {
  width: 20px;
  height: 20px;
  min-width: 20px;
  border: 2px solid var(--interview-brand-primary);
  border-radius: var(--interview-radius-sm);
  cursor: pointer;
  margin-top: 2px;
  accent-color: var(--interview-brand-primary);
  flex-shrink: 0;
}

.readiness-consentText {
  font-size: var(--interview-text-sm);
  color: var(--interview-success-dark);
  line-height: 1.6;
  flex: 1;
  font-weight: var(--interview-text-regular);
}

.readiness-consentText strong {
  font-weight: var(--interview-text-bold);
}

.readiness-consentList {
  margin: var(--interview-space-sm) 0 0 0;
  padding-left: var(--interview-space-xl);
  font-size: var(--interview-text-xs);
  color: var(--interview-brand-primary-dark);
  line-height: 1.7;
}

.readiness-consentList li {
  margin-bottom: var(--interview-space-xs);
}

.readiness-formLink {
  color: var(--interview-brand-primary-dark);
  text-decoration: underline;
  font-weight: var(--interview-text-medium);
  transition: color var(--interview-transition-base);
}

.readiness-formLink:hover {
  color: var(--interview-success-dark);
}

.readiness-footer {
  text-align: center;
  font-size: var(--interview-text-sm);
  color: var(--interview-text-muted);
  margin-top: var(--interview-space-lg);
  line-height: 1.6;
}

.readiness-supportLink {
  color: var(--interview-brand-primary);
  text-decoration: none;
  font-weight: var(--interview-text-medium);
  transition: color var(--interview-transition-base);
}

.readiness-supportLink:hover {
  text-decoration: underline;
  color: var(--interview-brand-primary-dark);
}

@media (max-width: 576px) {
  .readiness-heading {
    font-size: var(--interview-text-xl);
  }

  .readiness-checkItem {
    padding: 14px;
  }

  .readiness-checkIcon {
    width: 36px;
    height: 36px;
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Interview/ReadinessCheck/ReadinessCheck.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAI/C;EACE,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;EACvC,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,0CAA0C;EAC1C,gDAAgD;EAChD,iDAAiD;AACnD;;AAEA;EACE,gDAAgD;EAChD,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,SAAS;EACT,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,gDAAgD;EAChD,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,4DAA4D;EAC5D,+CAA+C;EAC/C,yCAAyC;EACzC,qCAAqC;EACrC,0CAA0C;EAC1C,2CAA2C;EAC3C,eAAe;EACf,oCAAoC;EACpC,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;EACE,gDAAgD;EAChD,kCAAkC;EAClC,yCAAyC;EACzC,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,yCAAyC;EACzC,eAAe;EACf,eAAe;EACf,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,gBAAgB;EAChB,OAAO;EACP,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,mCAAmC;EACnC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,kDAAkD;AACpD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,yCAAyC;EACzC,kDAAkD;AACpD;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* ==========================================\n   READINESS CHECK SCREEN - G42 BRANDING\n   ========================================== */\n\n@import '../../../styles/interview-theme.css';\n\n.readiness-container {\n  min-height: 100vh;\n  background: var(--interview-bg-main);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--interview-space-3xl) var(--interview-space-lg);\n  font-family: var(--interview-font-primary);\n}\n\n.readiness-heading {\n  font-size: 1.4375rem;\n  font-weight: var(--interview-text-bold);\n  color: var(--interview-text-primary);\n  margin: 0 0 7px 0;\n  text-align: center;\n  line-height: 1.3;\n  letter-spacing: 0;\n}\n\n.readiness-subheading {\n  font-size: 0.875rem;\n  color: var(--interview-text-muted);\n  margin: 0 0 24px 0;\n  text-align: center;\n  line-height: 1.6;\n  font-weight: var(--interview-text-regular);\n}\n\n.readiness-checksContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 11px;\n  margin-bottom: 22px;\n}\n\n.readiness-checkItem {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n  border-radius: var(--interview-radius-xl);\n  background-color: var(--interview-bg-card);\n  transition: all var(--interview-transition-base);\n  border: 1.5px solid var(--interview-border-light);\n}\n\n.readiness-checkItem.readiness-ok {\n  background-color: var(--interview-success-light);\n  border-color: var(--interview-success-border);\n}\n\n.readiness-checkItem.readiness-fail {\n  background-color: var(--interview-error-light);\n  border-color: var(--interview-error-border);\n}\n\n.readiness-checkItem.readiness-loading {\n  border-color: var(--interview-border-light);\n}\n\n.readiness-checkIcon {\n  width: 36px;\n  height: 36px;\n  border-radius: var(--interview-radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 19px;\n  background-color: var(--interview-bg-white);\n  flex-shrink: 0;\n}\n\n.readiness-checkItem.readiness-ok .readiness-checkIcon {\n  background: var(--interview-success-lighter);\n  color: var(--interview-brand-primary);\n}\n\n.readiness-checkItem.readiness-fail .readiness-checkIcon {\n  background: var(--interview-error-light);\n  color: var(--interview-error);\n}\n\n.readiness-checkItem.readiness-loading .readiness-checkIcon {\n  background: #EBF4FC;\n  color: #3D8FD6;\n}\n\n.readiness-checkContent {\n  flex: 1;\n  min-width: 0;\n}\n\n.readiness-checkTitle {\n  font-size: 0.875rem;\n  font-weight: var(--interview-text-semibold);\n  color: var(--interview-text-primary);\n  margin: 0 0 2px 0;\n  line-height: 1.3;\n}\n\n.readiness-checkDescription {\n  font-size: 0.78125rem;\n  color: var(--interview-text-muted);\n  margin: 0;\n  line-height: 1.4;\n  font-weight: var(--interview-text-regular);\n}\n\n.readiness-checkStatus {\n  width: 24px;\n  height: 24px;\n  border-radius: var(--interview-radius-circle);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 19px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.readiness-checkItem.readiness-ok .readiness-checkStatus {\n  color: var(--interview-brand-primary);\n}\n\n.readiness-checkItem.readiness-fail .readiness-checkStatus {\n  color: var(--interview-error);\n}\n\n.readiness-checkItem.readiness-loading .readiness-checkStatus {\n  color: #3D8FD6;\n}\n\n.readiness-spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid var(--interview-border-default);\n  border-top-color: var(--interview-brand-primary);\n  border-radius: var(--interview-radius-circle);\n  animation: readiness-spin 0.8s linear infinite;\n}\n\n@keyframes readiness-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.readiness-languageSection {\n  margin-bottom: var(--interview-space-2xl);\n}\n\n.readiness-languageLabel {\n  font-size: var(--interview-text-sm);\n  font-weight: var(--interview-text-semibold);\n  color: var(--interview-text-muted);\n  margin-bottom: var(--interview-space-sm);\n  display: block;\n}\n\n.readiness-languageSelect {\n  width: 100%;\n  padding: var(--interview-space-md) var(--interview-space-lg);\n  border: 1px solid var(--interview-border-light);\n  border-radius: var(--interview-radius-lg);\n  font-size: var(--interview-text-base);\n  font-family: var(--interview-font-primary);\n  background-color: var(--interview-bg-white);\n  cursor: pointer;\n  color: var(--interview-text-primary);\n  font-weight: var(--interview-text-medium);\n  transition: all var(--interview-transition-base);\n}\n\n.readiness-languageSelect:focus {\n  outline: none;\n  border-color: var(--interview-brand-primary);\n  box-shadow: var(--interview-shadow-focus);\n}\n\n.readiness-consentSection {\n  background-color: var(--interview-success-light);\n  padding: var(--interview-space-lg);\n  border-radius: var(--interview-radius-xl);\n  margin-bottom: var(--interview-space-2xl);\n  border: 1px solid var(--interview-success-border);\n}\n\n.readiness-consentCheckbox {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--interview-space-md);\n}\n\n.readiness-checkbox {\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  border: 2px solid var(--interview-brand-primary);\n  border-radius: var(--interview-radius-sm);\n  cursor: pointer;\n  margin-top: 2px;\n  accent-color: var(--interview-brand-primary);\n  flex-shrink: 0;\n}\n\n.readiness-consentText {\n  font-size: var(--interview-text-sm);\n  color: var(--interview-success-dark);\n  line-height: 1.6;\n  flex: 1;\n  font-weight: var(--interview-text-regular);\n}\n\n.readiness-consentText strong {\n  font-weight: var(--interview-text-bold);\n}\n\n.readiness-consentList {\n  margin: var(--interview-space-sm) 0 0 0;\n  padding-left: var(--interview-space-xl);\n  font-size: var(--interview-text-xs);\n  color: var(--interview-brand-primary-dark);\n  line-height: 1.7;\n}\n\n.readiness-consentList li {\n  margin-bottom: var(--interview-space-xs);\n}\n\n.readiness-formLink {\n  color: var(--interview-brand-primary-dark);\n  text-decoration: underline;\n  font-weight: var(--interview-text-medium);\n  transition: color var(--interview-transition-base);\n}\n\n.readiness-formLink:hover {\n  color: var(--interview-success-dark);\n}\n\n.readiness-footer {\n  text-align: center;\n  font-size: var(--interview-text-sm);\n  color: var(--interview-text-muted);\n  margin-top: var(--interview-space-lg);\n  line-height: 1.6;\n}\n\n.readiness-supportLink {\n  color: var(--interview-brand-primary);\n  text-decoration: none;\n  font-weight: var(--interview-text-medium);\n  transition: color var(--interview-transition-base);\n}\n\n.readiness-supportLink:hover {\n  text-decoration: underline;\n  color: var(--interview-brand-primary-dark);\n}\n\n@media (max-width: 576px) {\n  .readiness-heading {\n    font-size: var(--interview-text-xl);\n  }\n\n  .readiness-checkItem {\n    padding: 14px;\n  }\n\n  .readiness-checkIcon {\n    width: 36px;\n    height: 36px;\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
